angular.module('contentful').directive('cfAssetEditor', [
  'require',
  require => {
    var createEditorController = require('app/entity_editor/AssetController')
      .default;
    return {
      restrict: 'E',
      scope: {
        assetId: '<',
        preferences: '<'
      },
      template: JST.asset_editor(),
      controller: [
        '$scope',
        $scope => createEditorController($scope, $scope.assetId)
      ]
    };
  }
]);



// WEBPACK FOOTER //
// ./src/javascripts/app/asset_editor/cf_asset_editor_directive.js